import * as $ from 'jquery';
import {Global} from "../init-global";
import { TweenLite, Sine } from 'gsap';
const activated = [ TweenLite, Sine ];

require("gsap/src/uncompressed/plugins/ScrollToPlugin.js");


export class ScrollToAnchor
{
	protected $root: JQuery;

	constructor(elem: HTMLElement)
    {
        this.$root = $(elem);
        this.bindUI();
    }

    private bindUI = () => {
    	this.$root.on({
    		click: (e:any) => {
               let $link = $(e.currentTarget);
		       let href = $link.attr('href');
		       if (href.charAt(0) === '#') { this.doScroll($(href).first()); }
		       e.preventDefault();
            }
    	});
        
    }

    private doScroll = ($elem:JQuery) => {
    	TweenLite.to(window, 0.8, { scrollTo:{ y: $elem.offset().top }, ease: Sine.easeInOut });
    }
}